import {useNavigate} from 'react-router-dom';

import {AuthorizationsEnum} from 'presentation/constants';
import {useOpenOptionsDrawerStore} from 'presentation/pages/private/store/useOpenOptionsDrawer';

import {OptionsDrawerItem} from '../types';
import {translations} from 'presentation/translations-new';

const {authorizationsOdonto, authorizationsHealth} = translations['pt-br'].privateFlow.services;

function useAuthorizationItems() {
	const navigate = useNavigate();
	const closeOptionsDrawer = useOpenOptionsDrawerStore(state => state.closeOptionsDrawer);

	const handleAuthorizationsClick = (path: string) => {
		closeOptionsDrawer();
		navigate(path);
	};

	const items: OptionsDrawerItem[] = [
		{
			label: authorizationsHealth,
			icon: 'document-heart-outlined',
			onClick: () => handleAuthorizationsClick(AuthorizationsEnum.AUTHORIZATIONS),
		},
		{
			label: authorizationsOdonto,
			icon: 'document-tooth-outlined',
			onClick: () => handleAuthorizationsClick(AuthorizationsEnum.AUTHORIZATIONS_ODONTO),
		},
	];

	return {items};
}

export {useAuthorizationItems};
